import {useEffect} from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/components/popups';
import {loadPopups} from '../../../reducers/popups/actions';

import Popup from './popup';

export default () => {
    const {loaded, popups} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        if(!loaded)
            dispatch(loadPopups());
    }, [loaded]);

    const popup = popups.length > 0 ? popups[0] : null;

    if(!loaded)
        return <></>;

    return (
        <div className="popup-container">
            <AnimatePresence mode="wait">
                {popup && <Popup {...popup} />}
            </AnimatePresence>
        </div>
    )
}